/* Arflonia Mini-Warenkorb (wie Chewy) – 2026-10-29 Claude
   Desktop: Maus auf das Warenkorb-Symbol oben -> Vorschau mit Zwischensumme, Gratisversand-Fortschritt,
   „Warenkorb ansehen“, „Zur Kasse“ und den Artikeln. Handy/Tablet ohne Maus: unverändert (Tippen öffnet den Warenkorb).
   Einstellungen über das Script-Tag (snippets/arf-wa-minicart.liquid): data-free (Cent), data-kg, data-dog, data-cat. */
(function () {
  if (window.__arfMC) return;
  window.__arfMC = 1;
  var me = document.currentScript, cfg = (me && me.dataset) || {};
  var FREE = +cfg.free || 4900, MAXKG = +cfg.kg || 30;
  var DOG = cfg.dog || '/pages/hundebedarf', CAT = cfg.cat || '/pages/katzenbedarf';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEL = '.pets-desktop-cart';
  var mq = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var SKEL = '<span class="arf-mc__sk" style="width:62%"></span><span class="arf-mc__sk"></span><span class="arf-mc__sk" style="width:84%"></span><span class="arf-mc__sk" style="width:48%"></span>';
  var P = 'html:not(#mc1):not(#mc2) body ';
  var CSS =
    '.arf-mc{position:fixed;z-index:99990;top:0;left:0;width:360px;max-width:calc(100vw - 24px);background:#fff;color:#1F1F1F;border-radius:10px;box-shadow:0 16px 44px rgba(16,30,91,.22),0 2px 8px rgba(16,30,91,.08);font-size:14px;line-height:1.4;text-align:left;opacity:0;visibility:hidden;transform:translateY(-6px);transition:opacity .16s ease,transform .2s cubic-bezier(.2,.8,.2,1),visibility 0s linear .2s}' +
    '.arf-mc.is-open{opacity:1;visibility:visible;transform:none;transition:opacity .16s ease,transform .2s cubic-bezier(.2,.8,.2,1),visibility 0s}' +
    '.arf-mc::before{content:"";position:absolute;left:0;right:0;top:-14px;height:14px}' +
    '.arf-mc__caret{position:absolute;top:-6px;left:0;width:14px;height:14px;background:#fff;border-radius:3px 0 0 0;transform:rotate(45deg);box-shadow:-3px -3px 6px rgba(16,30,91,.06)}' +
    '.arf-mc__in{position:relative;padding:16px}' +
    '.arf-mc__sum{display:flex;justify-content:space-between;align-items:baseline;gap:12px;font-size:15px}' +
    '.arf-mc__sum span{font-weight:600}.arf-mc__sum b{font-size:16px;font-weight:700;white-space:nowrap}' +
    '.arf-mc__ship{margin:12px 0 0;font-size:13.5px;line-height:1.35}' +
    P + '.arf-mc svg{fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.arf-mc__ship svg{width:19px;height:19px;margin-left:6px;vertical-align:-5px}' +
    '.arf-mc__bar{display:block;height:8px;margin:8px 0 0;border-radius:99px;background:#E3E8F6;overflow:hidden}' +
    '.arf-mc__bar i{display:block;height:100%;border-radius:inherit;background:#324EB2;transition:width .45s cubic-bezier(.2,.8,.2,1)}' +
    '.arf-mc__btns{display:grid;gap:10px;margin:16px 0 0}' +
    '.arf-mc,.arf-mc *{box-sizing:border-box}' +
    P + '.arf-mc a.arf-mc__btn{box-sizing:border-box !important;display:flex !important;align-items:center !important;justify-content:center !important;gap:8px !important;width:100% !important;min-height:42px !important;margin:0 !important;padding:8px 14px !important;border-radius:8px !important;font-size:14.5px !important;font-weight:700 !important;line-height:1.2 !important;letter-spacing:0 !important;text-decoration:none !important;transform:none !important;transition:background-color .15s ease,box-shadow .2s ease,filter .2s ease !important}' +
    P + '.arf-mc a.arf-mc__btn--line,' + P + '.arf-mc a.arf-mc__btn--line:hover{background:#fff !important;border:1.5px solid #324EB2 !important;color:#324EB2 !important;-webkit-text-fill-color:#324EB2 !important;box-shadow:none !important}' +
    P + '.arf-mc a.arf-mc__btn--line:hover{background:#EEF1FA !important}' +
    P + '.arf-mc a.arf-mc__btn--go,' + P + '.arf-mc a.arf-mc__btn--go:hover{background:linear-gradient(110deg,#EA6224 0%,#C4470F 100%) !important;border:0 !important;color:#fff !important;-webkit-text-fill-color:#fff !important;box-shadow:0 6px 16px rgba(196,71,15,.28) !important}' +
    P + '.arf-mc a.arf-mc__btn--go:hover{filter:brightness(1.05);box-shadow:0 8px 22px rgba(196,71,15,.38) !important}' +
    P + '.arf-mc a.arf-mc__btn--line *{color:#324EB2 !important;-webkit-text-fill-color:#324EB2 !important}' +
    P + '.arf-mc a.arf-mc__btn--go *{color:#fff !important;-webkit-text-fill-color:#fff !important}' +
    P + '.arf-mc .arf-mc__btn svg{width:17px;height:17px;stroke-width:2.2;transition:transform .25s cubic-bezier(.2,.8,.2,1)}' +
    '.arf-mc__btn--go:hover svg{transform:translateX(3px)}' +
    '.arf-mc__list{list-style:none;margin:16px -16px -16px;padding:0;border-top:1px solid #E3E5EA;max-height:min(330px,45vh);overflow:auto;overscroll-behavior:contain;scrollbar-width:thin}' +
    '.arf-mc__it{display:grid;grid-template-columns:64px minmax(0,1fr);gap:12px;align-items:center;margin:0;padding:12px 16px;border-bottom:1px solid #E3E5EA}' +
    '.arf-mc__it:last-child{border-bottom:0}' +
    '.arf-mc__img{display:flex;align-items:center;justify-content:center;width:64px;height:64px;border-radius:6px;background:#F6F6F7;overflow:hidden}' +
    '.arf-mc__img img{width:84%;height:84%;object-fit:contain;mix-blend-mode:multiply}' +
    P + '.arf-mc a.arf-mc__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:#1F1F1F !important;-webkit-text-fill-color:#1F1F1F !important;text-decoration:none !important;font-size:13px;line-height:1.35}' +
    P + '.arf-mc a.arf-mc__t:hover{text-decoration:underline !important}' +
    '.arf-mc__t b{font-weight:700}' +
    '.arf-mc__v{display:block;margin-top:2px;font-size:12px;color:#5B5F6B}' +
    '.arf-mc__p{margin:4px 0 0;font-size:13.5px;font-weight:700}' +
    '.arf-mc__p s{margin-left:5px;font-size:12px;font-weight:400;color:#5B5F6B}' +
    '.arf-mc__p small{margin-left:5px;font-size:12.5px;font-weight:400;color:#5B5F6B}' +
    '.arf-mc__empty{text-align:center;padding:4px 0 0}.arf-mc__empty p{margin:0;font-size:15px;font-weight:600}' +
    '.arf-mc__sk{display:block;height:12px;margin:10px 0;border-radius:6px;background:linear-gradient(90deg,#EEF0F4 25%,#F7F8FA 50%,#EEF0F4 75%);background-size:200% 100%;animation:arfMcSk 1.1s linear infinite}' +
    '@keyframes arfMcSk{to{background-position:-200% 0}}' +
    SEL + '.is-mc-open{background-color:rgba(255,255,255,.14);box-shadow:0 0 0 6px rgba(255,255,255,.14);border-radius:10px}' +
    '.arf-mc-chev{display:none;flex:0 0 auto;width:15px;height:15px;margin-left:-4px;fill:none;stroke:currentColor;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round;transition:transform .22s cubic-bezier(.2,.8,.2,1)}' +
    '@media (hover:hover) and (pointer:fine){' + SEL + ' .arf-mc-chev{display:inline-block}}' +
    SEL + '.is-mc-open .arf-mc-chev{transform:rotate(180deg)}' +
    '@media (prefers-reduced-motion:reduce){.arf-mc,.arf-mc.is-open{transition:none}.arf-mc__sk{animation:none}}';

  var panel, inner, caret, anchor, showT, hideT, cache = null, busy = null, open = false;

  var NB = String.fromCharCode(160);
  function money(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + NB + '€'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function enabled() { return (!mq || mq.matches) && window.innerWidth >= 990; }

  var styled = false;
  function css() {
    if (styled) return;
    styled = true;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
  }
  /* kleiner Pfeil neben „Warenkorb“ (zeigt nach oben, solange die Vorschau offen ist) */
  function chev() {
    [].forEach.call(document.querySelectorAll(SEL), function (a) {
      var s = a.querySelector('.arf-mc-chev');
      if (!s) {
        s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        s.setAttribute('class', 'arf-mc-chev');
        s.setAttribute('viewBox', '0 0 24 24');
        s.setAttribute('aria-hidden', 'true');
        s.innerHTML = '<path d="M6 9l6 6 6-6"/>';
      }
      var t = a.querySelector('.arf-cart-t');
      if (t && t.parentNode) { if (t.nextSibling !== s) t.parentNode.insertBefore(s, t.nextSibling); }
      else if (s.parentNode !== a || a.lastChild !== s) a.appendChild(s);
    });
  }

  function build() {
    if (panel) return;
    css();
    panel = document.createElement('div');
    panel.className = 'arf-mc';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Warenkorb-Vorschau');
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML = '<span class="arf-mc__caret" aria-hidden="true"></span><div class="arf-mc__in"></div>';
    inner = panel.querySelector('.arf-mc__in');
    caret = panel.querySelector('.arf-mc__caret');
    document.body.appendChild(panel);
    panel.addEventListener('mouseenter', function () { clearTimeout(hideT); });
    panel.addEventListener('mouseleave', function (e) {
      if (anchor && e.relatedTarget && anchor.contains(e.relatedTarget)) return;
      later();
    });
  }

  function item(it) {
    var v = it.vendor || '', t = String(it.product_title || it.title || '').split(' | ')[0], suf = ' – ' + v;
    if (v && t.slice(-suf.length) === suf) t = t.slice(0, -suf.length);
    if (v && t.toLowerCase().indexOf(v.toLowerCase() + ' ') === 0) t = t.slice(v.length + 1);
    var u = it.url || (ROOT + 'products/' + it.handle);
    var disc = it.original_line_price > it.final_line_price;
    var vt = !it.product_has_only_default_variant && it.variant_title ? '<span class="arf-mc__v">' + esc(it.variant_title) + '</span>' : '';
    return '<li class="arf-mc__it"><a class="arf-mc__img" href="' + esc(u) + '" tabindex="-1" aria-hidden="true">' +
      (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy" decoding="async">' : '') + '</a>' +
      '<div><a class="arf-mc__t" href="' + esc(u) + '">' + (v ? '<b>' + esc(v) + '</b> ' : '') + esc(t) + '</a>' + vt +
      '<p class="arf-mc__p">' + money(it.final_line_price) + (disc ? '<s>' + money(it.original_line_price) + '</s>' : '') +
      '<small>(Menge: ' + it.quantity + ')</small></p></div></li>';
  }

  function render(c) {
    if (!c) {
      inner.innerHTML = '<div class="arf-mc__btns" style="margin:0"><a class="arf-mc__btn arf-mc__btn--line" href="' + ROOT + 'cart">Warenkorb ansehen</a></div>';
      return;
    }
    var n = c.item_count || 0;
    if (!n) {
      inner.innerHTML = '<div class="arf-mc__empty"><p>Dein Warenkorb ist leer</p></div><div class="arf-mc__btns">' +
        '<a class="arf-mc__btn arf-mc__btn--go" href="' + esc(DOG) + '">Für Hunde' + ARROW + '</a>' +
        '<a class="arf-mc__btn arf-mc__btn--line" href="' + esc(CAT) + '">Für Katzen</a></div>';
      return;
    }
    var total = c.total_price || 0, kg = (c.total_weight || 0) / 1000;
    var over = kg > MAXKG, free = !over && total >= FREE;
    var pct = free ? 100 : Math.max(2, Math.min(100, Math.floor(total * 100 / FREE)));
    var ship = over ? 'Über ' + MAXKG + ' kg: Versand nach Gewicht'
      : free ? 'Dein Versand ist <b>kostenlos!</b>'
      : 'Noch <b>' + money(FREE - total) + '</b> bis zum Gratisversand';
    inner.innerHTML =
      '<div class="arf-mc__sum"><span>Zwischensumme (' + n + ' Artikel):</span><b>' + money(total) + '</b></div>' +
      '<p class="arf-mc__ship">' + ship + TRUCK + '</p>' +
      (over ? '' : '<span class="arf-mc__bar" role="progressbar" aria-label="Fortschritt bis zum Gratisversand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></span>') +
      '<div class="arf-mc__btns"><a class="arf-mc__btn arf-mc__btn--line" href="' + ROOT + 'cart">Warenkorb ansehen</a>' +
      '<a class="arf-mc__btn arf-mc__btn--go" href="' + ROOT + 'checkout">Zur Kasse' + ARROW + '</a></div>' +
      '<ul class="arf-mc__list" role="list">' + (c.items || []).map(item).join('') + '</ul>';
  }

  function load() {
    if (busy) return busy;
    busy = fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) { cache = c; return c; })
      .catch(function () { return cache; })
      .then(function (c) { busy = null; return c; });
    return busy;
  }

  function place() {
    if (!anchor || !panel) return;
    var r = anchor.getBoundingClientRect();
    if (!r.width || r.bottom < 0) { close(); return; }
    var w = panel.offsetWidth || 360, vw = document.documentElement.clientWidth || window.innerWidth;
    var left = Math.round(Math.min(vw - w - 12, Math.max(12, r.right + 10 - w)));
    panel.style.left = left + 'px';
    panel.style.top = Math.round(r.bottom + 12) + 'px';
    caret.style.left = Math.round(Math.max(16, Math.min(w - 30, r.left + r.width / 2 - left - 7))) + 'px';
  }

  function show(a) {
    build();
    if (anchor && anchor !== a) anchor.classList.remove('is-mc-open');
    anchor = a;
    a.classList.add('is-mc-open');
    if (cache) render(cache); else inner.innerHTML = SKEL;
    place();
    open = true;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    load().then(function (c) { if (open) { render(c); place(); } });
  }
  function close() {
    clearTimeout(showT); clearTimeout(hideT);
    if (!panel || !open) return;
    open = false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (anchor) anchor.classList.remove('is-mc-open');
  }
  function later() { clearTimeout(showT); clearTimeout(hideT); hideT = setTimeout(close, 240); }

  document.addEventListener('mouseover', function (e) {
    var a = e.target && e.target.closest && e.target.closest(SEL);
    if (!a || !enabled()) return;
    if (e.relatedTarget && a.contains(e.relatedTarget)) return;
    clearTimeout(hideT); clearTimeout(showT);
    if (!cache) load();
    if (open && anchor === a) return;
    showT = setTimeout(function () { show(a); }, open ? 0 : 90);
  });
  document.addEventListener('mouseout', function (e) {
    var a = e.target && e.target.closest && e.target.closest(SEL);
    if (!a) return;
    var to = e.relatedTarget;
    if (to && (a.contains(to) || (panel && panel.contains(to)))) return;
    later();
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    var a = t && t.closest && t.closest(SEL);
    var kb = false;
    try { kb = !!(a && a.matches(':focus-visible')); } catch (err) { kb = false; }
    if (a && kb && enabled()) { clearTimeout(hideT); show(a); return; }
    if (open && panel && !panel.contains(t) && t !== anchor) close();
  });
  document.addEventListener('keydown', function (e) {
    if (open && (e.key === 'Escape' || e.key === 'Esc')) { var a = anchor; close(); if (a && a.focus) a.focus(); }
  });
  window.addEventListener('scroll', function () { if (open) place(); }, { passive: true });
  window.addEventListener('resize', function () { if (!open) return; if (!enabled()) close(); else place(); });

  /* 2026-11-04: Warenkorb im Leerlauf vorladen, damit Preise und Rabatte beim Überfahren sofort da sind (keine Wartezeit) */
  var lastWarm = 0;
  function warm() { try { var n = Date.now(); if (n - lastWarm < 1500 || !enabled()) return; lastWarm = n; load(); } catch (e) {} }
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2000 }); else setTimeout(warm, 800);
  window.addEventListener('pageshow', function (e) { if (e.persisted) warm(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') warm(); });
  try { var cc = document.querySelector('.pets-desktop-cart-count'); if (cc && window.MutationObserver) new MutationObserver(function () { warm(); }).observe(cc, { childList: true, characterData: true, subtree: true }); } catch (e) {}

  css();
  chev();
  window.addEventListener('load', chev);
  setTimeout(chev, 1500);
})();